"use strict";
/**
 * @class ShowCopyText
 * @description Component for displaying a truncated (by default) field the user can click to
 * see if they want to see the entire thing, as well as copy it to the clipboard.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Messages = require("../codegen/Messages");
var Clipboard_1 = require("./Clipboard");
var index_1 = require("../index");
var util_1 = require("../utils/util");
exports.ShowCopyText = function (_a) {
    var charactersToShow = _a.charactersToShow, fullText = _a.fullText, shortText = _a.shortText, testId = _a.testId;
    var shortTextFallback = util_1.truncate(fullText, charactersToShow);
    return (React.createElement(ShowCopyInternal, __assign({}, { fullText: fullText, testId: testId, shortText: shortText || shortTextFallback })));
};
function truncateDomainName(fqdn) {
    var portions = fqdn.split(".");
    var firstPortion = portions && portions[0];
    return firstPortion ? firstPortion + "..." : fqdn;
}
exports.ShowCopyDomainName = function (_a) {
    var fqdn = _a.fqdn, testId = _a.testId;
    return (React.createElement(ShowCopyInternal, __assign({}, { testId: testId, fullText: fqdn, shortText: truncateDomainName(fqdn) })));
};
var ShowCopyInternal = /** @class */ (function (_super) {
    __extends(ShowCopyInternal, _super);
    function ShowCopyInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { expanded: false };
        _this.toggleExpanded = _this.toggleExpanded.bind(_this);
        return _this;
    }
    ShowCopyInternal.prototype.toggleExpanded = function () {
        var expanded = this.state.expanded;
        this.setState({ expanded: !expanded });
    };
    ShowCopyInternal.prototype.render = function () {
        var expanded = this.state.expanded;
        var _a = this.props, fullText = _a.fullText, shortText = _a.shortText, testId = _a.testId, describedBy = _a.describedBy;
        var toggleLinkText = expanded ? Messages.Common.hide() : Messages.Common.show();
        return (React.createElement("span", __assign({ "data-test-id": testId, className: "oui-show-copy", "aria-expanded": expanded }, util_1.ariaProps({ describedBy: describedBy })),
            React.createElement("span", null, expanded ? fullText : shortText),
            React.createElement("span", { className: "oui-inline oui-margin-left", "data-name": "toggle-action" },
                React.createElement(index_1.Button, { buttonStyle: index_1.ButtonStyle.MutedLink, onClick: this.toggleExpanded, type: index_1.ButtonType.Button, role: "switch", pressed: expanded ? "true" : "false" }, toggleLinkText)),
            React.createElement("span", { className: "oui-inline oui-margin-left", "data-name": "copy-action" },
                React.createElement(Clipboard_1.ClipboardLink, { text: fullText }))));
    };
    return ShowCopyInternal;
}(React.Component));
exports.default = exports.ShowCopyText;
//# sourceMappingURL=ShowCopyText.js.map